import { Children, cloneElement, ComponentProps, isValidElement, memo, MouseEvent, ReactElement } from 'react'
import { Link as RouterLink } from '@tanstack/react-router'

type TChild =
  | ReactElement<{
      onClick?: (e: MouseEvent) => void
      to?: ComponentProps<typeof RouterLink>['to']
    }>
  | boolean
  | null
  | undefined

interface IProps {
  onClick: () => void
  children?: TChild | TChild[]
}

export const ChildItemsProxyClick = memo(function ChildItemsProxyClick({ children, onClick }: IProps) {
  return children && Array.isArray(children)
    ? (Children.map(children, (child) => {
        if (
          child &&
          isValidElement(child) &&
          child.props &&
          (typeof child.props.onClick === 'function' || child.props.to)
        ) {
          return cloneElement(child, {
            onClick: (e: MouseEvent) => {
              onClick()
              if (child.props.onClick) {
                child.props.onClick(e)
              }
            }
          })
        }

        return child
      }) as any as ReactElement<any, any>)
    : null
})
